import React, { useEffect, useState } from 'react';
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  Row,
  Table,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment-timezone';
import { listAllAnswers } from '../../actions/answerActions';
import AdminMainContainer from '../../components/AdminMainContainer';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import { trainingCentres } from '../../constants/trainingCentres';
import {
  EMPREENDEDOR,
  AUTONOMO,
  LIDER,
  COLABORADOR,
} from '../../constants/categoryConstants';
const AdminAnswersScreen = ({ history }) => {
  const dispatch = useDispatch();
  const [centre, setCentre] = useState('');
  const [answersState, setAnswersState] = useState([]);
  const [filtered, setFiltered] = useState(false);

  const { loading, answers, error } = useSelector(
    (state) => state.answerAdminList
  );

  useEffect(() => {
    dispatch(listAllAnswers());
  }, [dispatch]);

  const selectAnswers = () => {
    if (answersState.length === 0 && !filtered) {
      return answers;
    }

    return answersState;
  };

  const handlePrint = (e) => {
    e.preventDefault();
    window.print();
  };

  const getCentres = () => {
    return trainingCentres.sort().map((centre) => (
      <option value={centre} key={centre}>
        {centre}
      </option>
    ));
  };

  const filterAnswers = (e) => {
    e.preventDefault();
    const filteredAnswers = answers.filter((a) => {
      if (centre) {
        return a.centre === centre;
      }

      return a;
    });

    setFiltered(true);
    setAnswersState(filteredAnswers);
  };

  return (
    <AdminMainContainer>
      <Row>
        <Col>
          <h1>Respostas</h1>
        </Col>
        <Col className='text-right'>
          <Button
            type='button'
            variant='link'
            onClick={handlePrint}
            className='d-print-none'
          >
            <i className='fas fa-print'></i> Imprimir
          </Button>
        </Col>
      </Row>
      <Row className='d-print-none mb-4'>
        <Col xs={12}>
          <Accordion>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey='0'>
                Filtros
              </Accordion.Toggle>
              <Accordion.Collapse eventKey='0'>
                <Card.Body>
                  <Row>
                    <Col>
                      <Form.Group controlId='centre'>
                        <Form.Label>Núcleo</Form.Label>
                        <Form.Control
                          as='select'
                          onChange={(e) => setCentre(e.target.value)}
                          value={centre}
                        >
                          <option value=''>...</option>
                          {getCentres()}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className='align-self-center text-right'>
                      <Button
                        type='button'
                        onClick={filterAnswers}
                        style={{ fontSize: '0.9rem', padding: '3px 6px' }}
                        className='btn btn-outline-primary text-white'
                      >
                        Filtrar
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
      </Row>
      {answers.length === 0 && (
        <Message variant='primary'>Ainda não houveram respostas</Message>
      )}
      {error && <Message variant='danger'>{error}</Message>}
      {loading ? (
        <Loader />
      ) : (
        <div className='responsesTable'>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th
                  rowSpan={2}
                  colSpan={3}
                  className='text-center align-middle d-none d-print-table-cell'
                ></th>
                <th
                  rowSpan={2}
                  className='text-center align-middle d-print-none'
                >
                  Núcleo
                </th>
                <th
                  rowSpan={2}
                  className='text-center align-middle d-print-none'
                >
                  Nome
                </th>
                <th
                  rowSpan={2}
                  className='text-center align-middle d-print-none'
                >
                  Email
                </th>
                <th
                  rowSpan={2}
                  className='text-center align-middle d-print-none'
                >
                  Finalizado
                </th>
                <th
                  rowSpan={2}
                  className='text-center align-middle d-print-none'
                >
                  N&#186; respostas
                </th>
                <th
                  rowSpan={2}
                  className='text-center align-middle d-print-none'
                >
                  1&#170; Tentativa
                </th>
                <th rowSpan={2} className='text-center align-middle'>
                  Iniciado em
                </th>
                <th colSpan={4} className='text-center align-middle'>
                  Resultados
                </th>
                <th rowSpan={2} className='d-print-none'></th>
              </tr>
              <tr>
                <th className='text-center align-middle'>Empreendedor</th>
                <th className='text-center align-middle'>Autônomo</th>
                <th className='text-center align-middle'>Líder</th>
                <th className='text-center align-middle'>Colaborador</th>
              </tr>
            </thead>
            <tbody>
              {selectAnswers().map((answer) => (
                <tr key={answer.id}>
                  <td
                    colSpan={3}
                    className='align-middle d-none d-print-table-cell'
                  >
                    <strong>Núcleo:</strong> {answer.centre}
                    <br />
                    <strong>Nome:</strong> {answer.name}
                    <br />
                    <strong>Email:</strong> {answer.email}
                    <br />
                    <strong>Finalizado:</strong>{' '}
                    {!answer.completed ? (
                      <i className='fas fa-times text-danger'></i>
                    ) : (
                      <i className='fas fa-check text-success'></i>
                    )}
                    <br />
                    <strong>N&#186; respostas:</strong>{' '}
                    <span
                      className={answer.answer_count > 1 ? 'text-danger' : ''}
                    >
                      {answer.answer_count}
                    </span>
                    <br />
                    <strong>1&#170; Tentativa:</strong>{' '}
                    {answer.is_first_try ? (
                      <i className='fas fa-check text-success'></i>
                    ) : (
                      <i className='fas fa-times text-danger'></i>
                    )}
                    <br />
                  </td>
                  <td className='align-middle d-print-none'>{answer.centre}</td>
                  <td className='align-middle d-print-none'>{answer.name}</td>
                  <td className='align-middle d-print-none'>{answer.email}</td>
                  <td className='align-middle d-print-none'>
                    {answer.completed ? (
                      <i className='fas fa-check text-success'></i>
                    ) : (
                      <i className='fas fa-times text-danger'></i>
                    )}
                  </td>
                  <td
                    className={`align-middle d-print-none ${
                      answer.answer_count > 1 && 'text-danger'
                    }`}
                  >
                    {answer.answer_count}
                  </td>
                  <td className='align-middle d-print-none'>
                    {answer.is_first_try ? (
                      <i className='fas fa-check text-success'></i>
                    ) : (
                      <i className='fas fa-times text-danger'></i>
                    )}
                  </td>
                  <td className='align-middle text-left'>
                    <Moment format='DD/MM/YYYY HH:mm' tz='America/Sao_Paulo'>
                      {answer.createdAt}
                    </Moment>
                  </td>
                  <td className='align-middle text-left'>
                    {answer.results[EMPREENDEDOR]}
                  </td>
                  <td className='align-middle text-left'>
                    {answer.results[AUTONOMO]}
                  </td>
                  <td className='align-middle text-left'>
                    {answer.results[LIDER]}
                  </td>
                  <td className='align-middle text-left'>
                    {answer.results[COLABORADOR]}
                  </td>
                  <td className='d-print-none align-middle'>
                    <Link to={`/admin/answers/${answer.id}`} target='_blank'>
                      Resultado
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </AdminMainContainer>
  );
};

export default AdminAnswersScreen;
